import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import { Modal } from "react-bootstrap";



import Slider from "react-slick";

import { api } from "../Constants";

import axios from "axios";

import { toast } from "react-toastify";

import ReCAPTCHA from "react-google-recaptcha";

import Customarrows from "./Customarrows";

import { useSelector, useDispatch } from "react-redux";

import { addtoCart } from "../../features/cartSlice";



function Featureproduct({ datasss }) {

  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);



  var subject = "testing";



  const userid = localStorage.getItem("userid");



  const handleShow = (item) => {

    setShow(true);

    setFormData({

      ...formData,

      product_code: item.product_code,

      product_id: item.product_id,

      dealer_id: userid,

      subject: subject,

    });

  };



  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange1 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange2 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange3 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange4 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const [formData, setFormData] = useState({

    name: "",

    mobile: "",

    email: "",

    city: "",

    message: "",

    product_code: "",

    product_id: "",

  });



  const handleClick = () => {

    if (

      !formData.name == "" &&

      !formData.mobile == "" &&

      !formData.email == "" &&

      !formData.city == "" &&

      !formData.message == ""

    ) {

      fetch(api + "add_enquirydetails", {

        method: "GET",

        headers: {

          Accept: "application/json",

          "Content-Type": "application/json;charset=UTF-8",

          changeOrigin: true,

        },

        body: JSON.stringify(formData),

      }).then((response) => {

        if (response.status === 200) {

          alert("send message succesfully");

          handleClose();

        } else alert("some error is occured");

      });

    }

  };



  var settings = {

    dots: false,

    infinite: true,

    speed: 300,

    slidesToShow: 4,

    slidesToScroll: 1,

    autoplay: true,

    autoplaySpeed: 3000,

    arrows: true,

    prevArrow: <Customarrows className="slick-prev" isNext={false} />,

    nextArrow: <Customarrows className="slick-next" isNext={true} />,

    responsive: [

      {

        breakpoint: 1024,

        settings: {

          slidesToShow: 3,

          slidesToScroll: 1,

          infinite: true,

          dots: false,

        },

      },

      {

        breakpoint: 991,

        settings: {

          slidesToShow: 2,

          slidesToScroll: 1,

          infinite: true,

          dots: false,

        },

      },

      {

        breakpoint: 600,

        settings: {

          slidesToShow: 2,

          slidesToScroll: 1,

        },

      },

      {

        breakpoint: 480,

        settings: {

          slidesToShow: 1,

          slidesToScroll: 1,

        },

      },

    ],

  };



  const getProfile = async () => {

    await axios

      .post(api + "get_profile", {

        dealer_id: userid,

      })

      .then((res) => {

        if (res.data.data.name) {

          setFormData((prev) => ({

            ...prev,

            name: res.data.data.name,

          }));

        }



        if (res.data.data.mobile) {

          setFormData((prev) => ({

            ...prev,

            mobile: res.data.data.mobile,

          }));

        }



        if (res.data.data.email) {

          setFormData((prev) => ({

            ...prev,

            email: res.data.data.email,

          }));

        }

      })

      .catch((error) => {

        console.log(error);

      });

  };



  useEffect(() => {

    if (userid) {

      getProfile();

    }

  }, [userid]);



  const [showcart, setShowcart] = useState(false);

  const handleClosecart = () => setShowcart(false);



  const handleShowcart = (item) => {

    setShowcart(true);

    carsetFormData((prev) => ({

      ...prev,

      product_id: item.product_id,

      product_code: item.product_code,

      quantity_variant: item.quantity_variant || "Pair",

    }));

  };



  // Add this at the top of your component

  const [cartformData, carsetFormData] = useState({

    qty: "",

    sizes: "",

    carat: "",

    weight: "",

    remarks: "",

    quantity_variant: "",

  });

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");



  const carthandleChange = (e) => {

    const { name, value } = e.target;

    carsetFormData((prev) => ({

      ...prev,

      [name]: value,

    }));

  };



  const handleSubmit = async (e) => {

    e.preventDefault();



    const userids = userid;

    const product_id = parseInt(cartformData.product_id);

    const qty = parseInt(cartformData.qty);

    const size = cartformData.sizes;

    const carat = cartformData.carat;

    const weight = cartformData.weight;

    const remarks = cartformData.remarks;



    if (userid) {

      try {

        const resultAction = await dispatch(

          addtoCart({ product_id, userids, qty, size, carat, weight, remarks })

        );



        if (

          resultAction.meta.requestStatus === "fulfilled" ||

          resultAction.payload.success

        ) {

          // Adjust condition based on your setup

          handleClosecart();

          carsetFormData((prev) => ({

            ...prev,

            qty: "",

            sizes: "",

            carat: "",

            weight: "",

            remarks: "",

          }));

        }

      } catch (error) {

        console.error("Failed to add to cart:", error);

        // Handle error appropriately (e.g., show a message to the user)

      }

    }

  };



  return (

    <>

      {datasss.length > 0 ? (

        <>

          <div>

            <section class="product-area section-padding">

              <div class="container">

                <div class="row">

                  <div class="col-12">

                    <div class="section-title text-center">

                      <h2 class="title">feature products</h2>

                    </div>

                  </div>

                </div>

                <div class="row">

                  <div class="col-12">

                    <div class="product-container">

                      {datasss.length > 3 ? (

                        <Slider

                          {...settings}

                          className="slick-arrow-style slick-arrow-style_hero"

                        >

                          {datasss !== undefined && datasss.length > 0

                            ? datasss.map((item) => (

                                <div class="product-item">

                                  <figure class="product-thumb">

                                    <Link to={`/product-details/${item.slug}`}>

                                      <img

                                        className="pri-img"

                                        src={item.product_image}

                                        alt="Product"

                                      />

                                    </Link>



                                    <div className="cart-hover">

                                      {userid ? (

                                        <>

                                          <button

                                            className="btn btn-cart"

                                            onClick={() => {

                                              handleShowcart(item);

                                            }}

                                          >

                                            Add to Cart

                                          </button>

                                        </>

                                      ) : (

                                        <>

                                          <button

                                            className="btn btn-cart"

                                            onClick={() => {

                                              handleShow(item);

                                            }}

                                          >

                                            Enquiry Now

                                          </button>

                                        </>

                                      )}

                                    </div>

                                  </figure>

                                  <div class="product-caption text-center">

                                    <h6 class="product-name">

                                      <Link

                                        to={`/product-details/${item.slug}`}

                                      >

                                        {item.category_name}

                                      </Link>

                                    </h6>



                                    <div class="product-identity">

                                      <p class="manufacturer-name">

                                        Qty :{" "}

                                        <span className="price-regular">

                                          {item.quantity}&nbsp;{item.quantity_variant}

                                        </span>

                                      </p>

                                    </div>



                                    <div class="product-identity">

                                      <p class="manufacturer-name">

                                        Weight :{" "}

                                        <span className="price-regular">

                                          {item.weight} g

                                        </span>

                                      </p>

                                    </div>



                                    <div class="price-box">

                                      <span class="price-old">SKU :</span>

                                      <span class=" price-regular" style={{paddingLeft:'3px'}}>

                                        {item.product_code}{" "}

                                      </span>

                                    </div>

                                  </div>

                                </div>

                              ))

                            : null}

                        </Slider>

                      ) : datasss.length == 2 ? (

                        <>

                          <div

                            className="row"

                            style={{ justifyContent: "center" }}

                          >

                            {datasss.map((item, index) => {

                              return (

                                <div className="col-4">

                                  <div class="product-item">

                                    <figure class="product-thumb">

                                      <Link

                                        to={`/product-details/${item.slug}`}

                                      >

                                        <img

                                          className="pri-img"

                                          src={item.product_image}

                                          alt="Product"

                                        />

                                      </Link>

                                      <div class="cart-hover">

                                        <Link

                                          class="btn btn-cart"

                                          to={`/product-details/${item.slug}`}

                                        >

                                          View More{" "}

                                        </Link>

                                      </div>

                                    </figure>

                                    <div class="product-caption text-center">

                                      <h6 class="product-name">

                                        <Link

                                          to={`/product-details/${item.slug}`}

                                        >

                                          {item.category_name}

                                        </Link>

                                      </h6>



                                      <div class="product-identity">

                                        <p class="manufacturer-name">

                                          Qty :{" "}

                                          <span className="price-regular">

                                            {item.quantity}

                                          </span>

                                        </p>

                                      </div>



                                      <div class="product-identity">

                                        <p class="manufacturer-name">

                                          Weight :{" "}

                                          <span className="price-regular">

                                            {item.weight} g

                                          </span>

                                        </p>

                                      </div>



                                      <div class="price-box">

                                        <span class="price-old">SKU :</span>

                                        <span class=" price-regular">

                                          {item.product_code}{" "}

                                        </span>

                                      </div>

                                    </div>

                                  </div>

                                </div>

                              );

                            })}

                          </div>

                        </>

                      ) : datasss.length == 1 ? (

                        <>

                          <div

                            className="row"

                            style={{ justifyContent: "center" }}

                          >

                            {datasss.map((item, index) => {

                              return (

                                <div className="col-4">

                                  <div class="product-item">

                                    <figure class="product-thumb">

                                      <Link

                                        to={`/product-details/${item.slug}`}

                                      >

                                        <img

                                          className="pri-img"

                                          src={item.product_image}

                                          alt="Product"

                                        />

                                      </Link>

                                      <div class="cart-hover">

                                        <Link

                                          class="btn btn-cart"

                                          to={`/product-details/${item.slug}`}

                                        >

                                          View More

                                        </Link>

                                      </div>

                                    </figure>

                                    <div class="product-caption text-center">

                                      <h6 class="product-name">

                                        <Link

                                          to={`/product-details/${item.slug}`}

                                        >

                                          {item.category_name}

                                        </Link>

                                      </h6>



                                      <div class="product-identity">

                                        <p class="manufacturer-name">

                                          Weight :{" "}

                                          <span className="price-regular">

                                            {item.weight} g

                                          </span>

                                        </p>

                                      </div>



                                      <div class="price-box">

                                        <span class="price-old">SKU :</span>

                                        <span class=" price-regular">

                                          {item.product_code}

                                        </span>

                                      </div>



                                      <div class="product-identity mt-2">

                                        <p class="manufacturer-name">

                                          Qty :{" "}

                                          <span className="price-regular">

                                            {item.quantity}

                                          </span>

                                        </p>

                                      </div>

                                    </div>

                                  </div>

                                </div>

                              );

                            })}

                          </div>

                        </>

                      ) : null}



                      <Modal

                        show={show}

                        onHide={handleClose}

                        className="modal fade entry-popup"

                      >

                        <div className="modal-header">

                          <h5 className="modal-title" id="exampleModalLabel">

                            {" "}

                            <span>For Enquiry Enter Your Details</span>

                          </h5>

                          <button

                            type="button"

                            className="close"

                            data-dismiss="modal"

                            aria-label="Close"

                            style={{ border: "none" }}

                            onClick={() => {

                              setShow(false);

                            }}

                          >

                            <span

                              className="contactclosebutton"

                              aria-hidden="true"

                            >

                              &times;

                            </span>

                          </button>

                        </div>

                        <Modal.Body>

                          <form method="POST" action="javascript:void(0)">

                            <div className="row mb3 g-3">

                              <div className="col-lg-12 col-md-12 mb20">

                                <input

                                  type="text"

                                  className="form-control"

                                  placeholder="Your Name"

                                  id="name"

                                  name="name"

                                  value={formData.name}

                                  onChange={handleChange}

                                  onKeyPress={(event) => {

                                    if (!/[a-z,A-Z]/.test(event.key)) {

                                      event.preventDefault();

                                    }

                                  }}

                                  required

                                ></input>

                              </div>

                              <div className="col-lg-12 col-md-12 mb20">

                                <input

                                  type="text"

                                  className="form-control"

                                  placeholder="Phone Number"

                                  id="mobile"

                                  name="mobile"

                                  value={formData.mobile}

                                  onChange={handleChange1}

                                  maxLength="10"

                                  onKeyPress={(event) => {

                                    if (!/[0-9]/.test(event.key)) {

                                      event.preventDefault();

                                    }

                                  }}

                                  required

                                ></input>

                              </div>

                              <div className="col-lg-12 col-md-12 mb20">

                                <input

                                  type="email"

                                  className="form-control"

                                  placeholder="Email Address"

                                  id="email"

                                  name="email"

                                  value={formData.email}

                                  onChange={handleChange2}

                                  required

                                ></input>

                              </div>

                              <div className="col-lg-12 col-md-12 mb20">

                                <input

                                  type="text"

                                  className="form-control"

                                  placeholder="Enter Your City"

                                  id="city"

                                  name="city"

                                  value={formData.city}

                                  onChange={handleChange4}

                                  required

                                ></input>

                              </div>



                              <div class="col-lg-12 col-sm-12 mb20">

                                <textarea

                                  type="Message"

                                  class="form-control"

                                  placeholder="Message"

                                  id="message"

                                  name="message"

                                  value={formData.message}

                                  onChange={handleChange3}

                                  required

                                ></textarea>

                                <small id="messageerror" class="error"></small>

                              </div>

                              <div>

                                {/* <div className="col-lg-12 col-md-12 mb20">

                            <ReCAPTCHA

                              sitekey={

                                "6LdGiY0oAAAAAH9EQi94D43RkIXkRWpc1x99AUTv"

                              }

                              Secret

                              Key={"6LdGiY0oAAAAALltd2vMsg0i0HeJ9J33rYDM7pnP"}

                              className="g-recaptcha my-3"

                              onChange={onChange}

                            />

                          </div> */}

                                <input

                                  type="hidden"

                                  id="product_code"

                                  name="product_code"

                                  value={formData.product_code}

                                  readOnly

                                />

                                <input

                                  type="hidden"

                                  id="product_id"

                                  name="product_id"

                                  value={formData.product_id}

                                  readOnly

                                />

                                <Modal.Footer className="validationpopup-button-sec">

                                  <button

                                    className="main-btn mr2"

                                    download=""

                                    onClick={handleClick}

                                  >

                                    Submit

                                  </button>

                                  <button

                                    type="close"

                                    className="main-btn ml2 closebtn"

                                    data-dismiss="modal"

                                    onClick={() => {

                                      setShow(false);

                                    }}

                                  >

                                    close

                                  </button>

                                </Modal.Footer>

                              </div>

                            </div>

                          </form>

                        </Modal.Body>

                      </Modal>



                      <Modal

                        show={showcart}

                        onHide={handleClosecart}

                        keyboard={false}

                        backdrop="static"

                        className="entry-popup"

                        centered

                      >

                        <div className="modal-header mb-3">

                          <h5 className="modal-title">Add Cart</h5>

                          <button

                            type="button"

                            className="close"

                            onClick={handleClosecart}

                            style={{ border: "none" }}

                          >

                            <span className="contactclosebutton">&times;</span>

                          </button>

                        </div>



                        <Modal.Body>

                          <form onSubmit={handleSubmit}>

                            {/* {error && <div className="alert alert-danger">{error}</div>} */}



                            <div className="row g-3">

                              {/* Update all inputs to use cartformData */}



                              <div className="col-12 mb20 add_to_cart_popup">

                                <div className="input_inner_box">

                                  <input

                                    type="text"

                                    className="form-control"

                                    placeholder="Quantity"

                                    name="qty"

                                    value={cartformData.qty}

                                    onChange={carthandleChange}

                                    required

                                  />

                                  <span className="input_sub_inner_box">

                                    {cartformData.quantity_variant}

                                  </span>

                                </div>

                              </div>



                              {/** Sizes **/}

                              <div className="col-12 mb20 add_to_cart_popup">

                                <div className="input_inner_box">

                                  <input

                                    type="text"

                                    className="form-control"

                                    placeholder="Sizes"

                                    name="sizes"

                                    value={cartformData.sizes}

                                    onChange={carthandleChange}

                                    required

                                  />

                                  <span className="input_sub_inner_box">

                                    / 16

                                  </span>

                                </div>

                              </div>



                              {/** Carat **/}

                              <div className="col-12 mb20 add_to_cart_popup">

                                <div className="input_inner_box">

                                  <select

                                    className="form-control"

                                    name="carat"

                                    value={cartformData.carat}

                                    onChange={carthandleChange}

                                    required

                                  >

                                    <option value="" disabled>

                                      Select Carat

                                    </option>

                                    <option value="22 KT">22 KT</option>

                                    <option value="18 KT Yellow Gold">

                                      18 KT Yellow Gold

                                    </option>

                                    <option value="18 KT Rose Gold">

                                      18 KT Rose Gold

                                    </option>

                                    <option value="18 KT White Gold">

                                      18 KT White Gold

                                    </option>



                                    {/* Add more options as needed */}

                                  </select>

                                  <span className="input_sub_inner_box">

                                    CT

                                  </span>

                                </div>

                              </div>



                              {/** Weight **/}

                              <div className="col-12 mb20 add_to_cart_popup">

                                <div className="input_inner_box">

                                  <input

                                    type="text"

                                    className="form-control"

                                    placeholder="Weight"

                                    name="weight"

                                    value={cartformData.weight}

                                    onChange={carthandleChange}

                                    required

                                  />

                                  <span className="input_sub_inner_box">

                                    gms

                                  </span>

                                </div>

                              </div>



                              {/** Remarks **/}

                              <div className="col-12 mb20">

                                <textarea

                                  rows={5}

                                  className="form-control"

                                  placeholder="Remarks"

                                  name="remarks"

                                  value={cartformData.remarks}

                                  onChange={carthandleChange}

                                  required

                                />

                              </div>

                            </div>



                            <Modal.Footer>

                              <button type="submit" className="main-btn mr2 ">

                                {loading ? "Submitting..." : "Submit"}

                              </button>

                              <button

                                type="button"

                                className="main-btn ml2 closebtn"

                                onClick={handleClosecart}

                              >

                                Close

                              </button>

                            </Modal.Footer>

                          </form>

                        </Modal.Body>

                      </Modal>

                    </div>

                  </div>

                </div>

              </div>

            </section>

          </div>

        </>

      ) : null}

    </>

  );

}

export default Featureproduct;

